module.exports = __webpack_public_path__ + "img/cloth_g3_shirt-05.6f75b257.svg";